import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '..';

const DEFAULT_TENANT_SLUG = 'xcover-partner';

export interface TenantState {
  tenantSlug: string;
}

const initialState: TenantState = {
  tenantSlug: DEFAULT_TENANT_SLUG,
};

const tenantSlice = createSlice({
  name: 'tenant',
  initialState,
  reducers: {
    setTenantSlug(state, action: PayloadAction<string>) {
      state.tenantSlug = action.payload;
    },
  },
});

export const { setTenantSlug } = tenantSlice.actions;
export const selectTenantSlug = (state: RootState) => state.tenant.tenantSlug;
export default tenantSlice.reducer;
